import productAction from '../../actions/shop/products';
import CRUDReducer from '../CRUDReducer';

const productCRUDReducer = new CRUDReducer(productAction);

export default (state, action) => productCRUDReducer.run(state, action);




// WEBPACK FOOTER //
// ./src/reducers/shop/product.js